export default "__VITE_ASSET__CjCO8wg9__"